import { type SVGProps } from "react";

interface IProps extends SVGProps<SVGSVGElement> {}

export const Facebook = (props: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 41 41"
      {...props}
    >
      <path
        fill="inherit"
        d="M22.88 14.107v3.476h4.3l-.68 4.683h-3.62v10.788a16.2 16.2 0 0 1-4.777-.05V22.266h-3.966v-4.683h3.966V13.33a4.78 4.78 0 0 1 4.778-4.78v.003l.023-.002h4.278v4.05h-2.796c-.83 0-1.505.674-1.505 1.504z"
      />
    </svg>
  );
};
